import Swiper, { Pagination, Navigation, Autoplay } from 'swiper';
Swiper.use([Pagination, Navigation, Autoplay]);

export function initTalentHeroSlider() {
   const el = document.querySelector('.talent-hero-swiper');
   if (!el) return;

   new Swiper(el, {
      direction: 'horizontal',
      loop: true,
      autoplay: {
         delay: 4000,
         disableOnInteraction: false,
      },
      pagination: {
         el: el.querySelector('.talent-hero-swiper__pagination'),
         clickable: true,
      },
      navigation: {
         prevEl: el.querySelector('.talent-hero-swiper__prev'),
         nextEl: el.querySelector('.talent-hero-swiper__next'),
      },
   });
}

export function initVitaShowMore() {
   document.querySelectorAll('.vita-show-more').forEach((btn) => {
      const list = btn.previousElementSibling;
      const hidden = [...list.querySelectorAll('.vita-entry--hidden')];

      // Wrap each hidden entry so jQuery can slideDown/Up the wrapper
      // without touching the entry's display:grid
      hidden.forEach((entry) => {
         $(entry).wrap('<div class="vita-entry-wrap" style="display:none;overflow:hidden;">');
      });

      btn.addEventListener('click', () => {
         const expanding = !list.classList.contains('is-expanded');

         if (expanding) {
            list.classList.add('is-expanded');
            hidden.forEach((entry, i) => {
               setTimeout(() => $(entry).parent().slideDown(300), i * 50);
            });
            btn.textContent = 'Show less';
         } else {
            hidden.forEach((entry) => $(entry).parent().slideUp(300));
            setTimeout(() => list.classList.remove('is-expanded'), 300);
            btn.textContent = 'Show all';
         }
      });
   });
}

export function initTalentTabs() {
   const page = document.querySelector('.talent-page');
   if (!page) return;

   const tabs = page.querySelectorAll('.talent-tabs__item');
   const sections = page.querySelectorAll('.talent-section');

   const activate = (target) => {
      tabs.forEach((t) => t.classList.toggle('is-active', t.dataset.tab === target));
      sections.forEach((s) => {
         s.hidden = s.id !== target;
      });
   };

   tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
         e.preventDefault();
         if (tab.classList.contains('is-active')) return;
         const target = tab.dataset.tab;
         history.replaceState(null, '', '#' + target);
         activate(target);
      });
   });

   // Activate from URL hash, default to first available tab
   const hash = window.location.hash.replace('#', '');
   const validTabs = [...tabs].map((t) => t.dataset.tab);
   activate(validTabs.includes(hash) ? hash : validTabs[0]);
}
